import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import SimpleCrudsTemplate from '../../../components/templates/v2/SimpleCrudsTemplate'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { PermissionChecker } from '../../session'
import AddNewButton from './AddNewButton'
import PageContent from './PageContent'
import PageHeader from './PageHeader'

const GroupsListPage = props => {
  return (
    <PermissionChecker module="setupUser">
      <SimpleCrudsTemplate>
        <FilterHandler initialState={{}}>
          <PageHeader />
          <PageContent />
        </FilterHandler>
        <AddNewButton />
        <Separator weight={90} />
      </SimpleCrudsTemplate>
    </PermissionChecker>
  )
}

export default GroupsListPage
